module.exports = __webpack_public_path__ + "static/media/home-03.f0173f5b.png";